"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiSuccessFill16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 -3.55271368e-15,12.418278 -1.77635684e-15,8 C-1.77635684e-15,3.581722 3.581722,0 8,0 Z M10.4748737,4.81801948 L6.93933983,8.35355339 L5.52512627,6.93933983 L4.1109127,8.35355339 L6.93933983,11.1819805 L11.8890873,6.23223305 L10.4748737,4.81801948 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Success',
    width: 16,
    height: 16,
};
var muiSuccessFill24 = {
    paths: [
        {
            path: 'M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M14.8181818,6 L9.36363636,11.4555554 L7.18181818,9.27333323 L5,11.4555554 L9.36363636,15.8199997 L17,8.18222215 L14.8181818,6 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Success',
    width: 22,
    height: 22,
};
var muiSuccessFill = {
    base: muiSuccessFill16,
    smIcon: muiSuccessFill16,
    lgIcon: muiSuccessFill24,
};
exports.muiSuccessFill = muiSuccessFill;
//# sourceMappingURL=successFill.js.map